import { render, staticRenderFns } from "./busModel.vue?vue&type=template&id=47b188fc&scoped=true&"
import script from "./busModel.vue?vue&type=script&lang=js&"
export * from "./busModel.vue?vue&type=script&lang=js&"
import style0 from "./busModel.vue?vue&type=style&index=0&id=47b188fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b188fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
